export const STATUS_LABELS = {
  live: 'Live',
  draft: 'Draft',
  sent: 'Sent',
  open: 'Open',
  closed: 'Closed',
  scheduled: 'Scheduled',
  launching: 'Launching',
  paused: 'Paused',
  aborted: 'Aborted',
}

export const STATUS_CLASS = {
  live: 'live',
  draft: 'draft',
  sent: 'sent',
  open: 'open',
  closed: 'closed',
  scheduled: 'draft',
  launching: 'draft',
  paused: 'closed',
  aborted: 'closed',
}

export const ENTITY_CONFIG = {
  Campaign: {
    Icon: SvgIconsCampaigns,
    getLabel: () => 'campaign',
    getStatus: (bookmark) => bookmark.status,
    getMetric: (bookmark) => {
      const count = bookmark.search?.targetCount
      if (count == null || count === 0) return null
      return { n: Number(count).toLocaleString(), lbl: 'recipients' }
    },
    getUrl: (bookmark) =>
      ['draft', 'scheduled'].includes(bookmark.status)
        ? `/admin/campaigns/${bookmark.id}/build`
        : `/admin/campaigns/${bookmark.id}/overview`,
  },
  Flow: {
    // Pages.jsx declares viewBox 0 0 52 60 with content in the top-left ~20×24,
    // relying on an inline transform we strip in .type-icon. Override viewBox tight to content.
    Icon: (props) => <SvgIconsPages viewBox="0 0 20 24" {...props} />,
    getLabel: ({ section } = {}) => (section === 'ballots' ? 'ballot' : 'page'),
    getStatus: (bookmark) => bookmark.status,
    getMetric: (bookmark) => {
      if (!bookmark.templateName) return null
      return { lbl: bookmark.templateName }
    },
    getUrl: (bookmark) => `/admin/flows/${bookmark.id}/overview`,
  },
  Dashboard: {
    Icon: SvgIconsLineChart,
    getLabel: () => 'dashboard',
    getStatus: (bookmark) => bookmark.status,
    getMetric: (bookmark) => {
      const count = bookmark.search?.targetCount
      if (count == null || count === 0) return null
      return { n: Number(count).toLocaleString(), lbl: 'people' }
    },
    getUrl: (bookmark) => `/admin/dashboards/${bookmark.id}/overview`,
  },
}

export const DEFAULT_VISIBLE = 3
